import { t } from "i18next";
import * as React from "react";
import {
  AddButton,
  ButtonsContainer,
  CancelButton,
} from "../addClientModal/addClientModal.styles";
import CreatableSelect from "react-select/creatable";
import {
  Get,
  Patch,
  PatchFormData,
  handleError,
} from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import { createFormData } from "../addUserModal/addUserModal.component";
import { toast } from "react-toastify";
import { FilePond } from "react-filepond";

interface UpdateCompanyModelProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
}

interface updateCompany {
  name: string;
  about: string;
  logo: string;
  company_images: string[];
  contact_emails: any[];
  contact_numbers: any[];
}

const UpdateCompanyModel: React.FC<UpdateCompanyModelProps> = ({
  setOpen,
  open,
}) => {
  const defaultUpdateCompany = {
    name: "",
    about: "",
    logo: "",
    company_images: [],
    contact_emails: [],
    contact_numbers: [],
  };
  const [updateCompany, setUpdateCompany] =
    React.useState<updateCompany>(defaultUpdateCompany);
  const [, setCompany] =
    React.useState<updateCompany>(defaultUpdateCompany);
  const { getValidToken } = React.useContext(UserContext);
  const [logoFile, setLogoFile] = React.useState<any[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [images, setImages] = React.useState<any[]>([]);

  const getCompanyForAdmin = async () => {
    const res = await Get("company/get-company-for-admin", getValidToken());

    if (res.error || !res.data) {
      handleError(res);
      return;
    }

    setUpdateCompany({
      name: res.data.name,
      about: res.data.about,
      logo: res.data.logo,
      company_images: res.data.CompanyImages?.map((item: any) => {
        return item.image;
      }),
      contact_emails: res.data.CompanyContactMails?.map((item: any) => {
        return {
          label: item.mail,
          value: item.id,
        };
      }),
      contact_numbers: res.data.CompanyContactNumbers?.map((item: any) => {
        return {
          label: item.phone_number,
          value: item.id,
        };
      }),
    });

    setCompany({
      name: res.data.name,
      about: res.data.about,
      logo: res.data.logo,
      company_images: res.data.CompanyImages?.map((item: any) => {
        return item.image;
      }),
      contact_emails: res.data.CompanyContactMails?.map((item: any) => {
        return {
          label: item.mail,
          value: item.id,
        };
      }),
      contact_numbers: res.data.CompanyContactNumbers?.map((item: any) => {
        return {
          label: item.phone_number,
          value: item.id,
        };
      }),
    });

    setLogoFile([`${import.meta.env.VITE_API_URL}${res.data.logo}`]);

    setImages(
      res.data.CompanyImages.map(
        (url: any) => `${import.meta.env.VITE_API_URL}${url.image}`,
      ),
    );
  };

  const handleUpdateCompany = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = createFormData({
      name: updateCompany.name,
      about: updateCompany.about,
    });

    const logoModified =
      logoFile?.length > 0 && logoFile[0]?.file !== undefined;

    if (logoModified) {
      logoFile.forEach((item) => formData.append("logo", item.file));
    }

    images
      .map((item) => item.file)
      .forEach((file) => formData.append("company_images", file));

    // if (updateCompany.company_images.length > 0) {
    //   for (let i = 0; i < updateCompany.company_images.length; i++) {
    //     formData.append("company_images", updateCompany.company_images[i]);
    //   }
    // }

    const response = await PatchFormData(
      "company/update-company",
      formData,
      getValidToken(),
    );

    const response2 = await Patch(
      "company/update-company-contacts",
      {
        contact_emails: updateCompany.contact_emails.map((item) => item.label),
        contact_numbers: updateCompany.contact_numbers.map(
          (item) => item.label,
        ),
      },
      getValidToken(),
    );

    if (response.error || (!response.data && response2.error)) {
      handleError(response);
      setIsLoading(false);
      return;
    }
    toast.success("Updated");
    setOpen(false);
    setIsLoading(false);
    getCompanyForAdmin();
  };

  React.useEffect(() => {
    getCompanyForAdmin();
  }, [open]);

  // console.log(Array.isArray(logoFile));

  // console.log(images);

  return (
    <div
      className={`toggle_server_model fixed top-0 left-0 w-full h-full bg-[#00000075] flex items-center justify-center !z-[99999] ${
        open ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className="fixed top-0 left-0 w-full h-[100vh] cursor-pointer"
        onClick={() => {
          setOpen(false);
        }}
      ></div>
      <form
        className={`bg-white w-full max-w-[500px] p-6 relative z-[9999] max-h-[85vh] overflow-y-auto`}
        onSubmit={handleUpdateCompany}
      >
        <h2 className="text-3xl mb-6 !text-black">{t("update_company")}</h2>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("adminDashboard__name")}</label>
          <input
            onChange={(e) =>
              setUpdateCompany((prev) => {
                return { ...prev, name: e.target.value };
              })
            }
            value={updateCompany.name}
            name="name"
            className="border"
            type="text"
            required
          />
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("adminDashboard__about")}</label>
          <input
            onChange={(e) =>
              setUpdateCompany((prev) => {
                return { ...prev, about: e.target.value };
              })
            }
            value={updateCompany.about}
            name="name"
            className="border"
            type="text"
            required
          />
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("logo")}</label>
          <FilePond
            files={logoFile}
            onupdatefiles={(files) => {
              setLogoFile(files);
            }}
            allowMultiple={false}
            allowReorder
            allowImagePreview
            allowImageExifOrientation
            maxFiles={1}
            name="files"
            labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
            className={"!mb-0"}
          />
          {/* {updateCompany.logo && (
            <Image
              src={
                Array.isArray(logoFile) && logoFile?.length > 0
                  ? URL.createObjectURL(logoFile[0]?.file)
                  : logoFile?.source
              }
              className="w-[80px] h-[80px] object-contain rounded"
              alt={"image company"}
              addBaseLink={false}
            />
          )} */}
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("company_images")}</label>
          <FilePond
            files={images}
            onupdatefiles={(files) => {
              setImages(files);
            }}
            allowMultiple={true}
            allowReorder
            allowImagePreview
            allowImageExifOrientation
            maxFiles={10}
            acceptedFileTypes={["image/jpeg", "image/png", "image/avif"]}
            credits={false}
            labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
          />
          {/* {companyImagesRef?.current?.files?.length > 0 ? (
            <div className="flex items-center gap-3">
              {[...companyImagesRef?.current?.files].map((image) => {
                console.log(image);

                return (
                  <Image
                    src={URL.createObjectURL(image)}
                    className="w-[80px] h-[80px] object-contain rounded"
                    alt={"image company"}
                    addBaseLink={false}
                  />
                );
              })}
            </div>
          ) : (
            <div className="flex items-center gap-3">
              {updateCompany.company_images.map((image) => (
                <Image
                  src={image}
                  className="w-[80px] h-[80px] object-contain"
                  alt={"image company"}
                  addBaseLink={true}
                />
              ))}
            </div>
          )} */}
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("contact_emails")}</label>
          <CreatableSelect
            isClearable
            isMulti
            closeMenuOnSelect={false}
            value={updateCompany?.contact_emails}
            onChange={(selectedOption) => {
              //   console.log(selectedOption);
              setUpdateCompany((prev) => ({
                ...prev,
                contact_emails: [...selectedOption],
              }));
            }}
          />
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label>{t("contact_numbers")}</label>
          <CreatableSelect
            isClearable
            isMulti
            closeMenuOnSelect={false}
            value={updateCompany?.contact_numbers}
            onChange={(selectedOption) => {
              //   console.log(selectedOption);
              setUpdateCompany((prev) => ({
                ...prev,
                contact_numbers: [...selectedOption],
              }));
            }}
          />
        </div>
        <ButtonsContainer style={{ gap: "2rem" }}>
          <AddButton
            style={{ backgroundColor: "#64A7C4" }}
            isLoading={isLoading}
            type="submit"
          >
            {t("submit")}
          </AddButton>
          <CancelButton
            type="button"
            style={{ border: "2px solid black" }}
            onClick={() => setOpen(false)}
          >
            {t("cancelBtn")}
          </CancelButton>
        </ButtonsContainer>
      </form>
    </div>
  );
};

export default UpdateCompanyModel;
